module.exports = __webpack_public_path__ + "static/media/header-logo.a9dd48a8.svg";